import * as firebase from 'firebase';
require("firebase/firestore");
var datetime = new Date();



var collectionMeta={
/*	"events":{
		"fields":{
			"name":"Event name",
			"tickets":["some"],
			"location":new firebase.firestore.GeoPoint(41.22, 22.34)
		},
		"collections":["tickets"],
	},
	"tickets":{
		"fields":{
			"price":"300",
			"name":"Regular"
		},
		"collections":[],
	},*/

	"cliniques":{
		"fields":{
					"categories_videos":"",
					"idioma":",español",
			        "logo":"",
                    "portada":"",
                    "portada1":"",    
                    "portada2":"",    
                    "portada3":"",    
                    "portada4":"",    
                    "mail":"",
                    "colorPrimari":"",
					"colorSecundari":"",
                    "title":"Nova clínica",
                    "direccio":"",
                    "telefon":"",
                    "descrip":["","català","english"]
		},
	},


	"videos_corporativos":{
		"fields":{
			"video":"",
			"title":"Nombre del Vídeo",
			"photo":"",
			"tags":"tags",
			"created": datetime,
			"updated": datetime,
			"video_idioma_corporativo":",español",
			"video_plan" : ",standard",
			"categories1":"undefined",
			"categories2":"undefined",
			"categories3":"undefined",
			"categories4":"undefined",
			"categories5":"undefined",
			"sub_es":"",
		},
                //"collections":[],
        },
	 

	"videos_disponibles":{
		"fields":{
                    "a_title":"",
                    "clinica":"",
					"descripcio":"", 
					"preview":"",   
                    "app":"",    
					"tablet":"", 
					"tv":"", 
					"idclinica":"",   
                    "idvideo":""  
					
					 
		},
	},

	"promocions":{
		"fields":{
                    "title":"",
                    "idclinica":"",
					"idplaylist":"", 
					"photo":"",   
					"codi_playlist":"",   
					"tipo_promo":"",
					"color_fondo_promo":"",
					"color_letra_promo":"",
					"letra_promocion":"",
					"categoria_anuncios_1":"",
					"categoria_anuncios_2":"",
					"categoria_anuncios_3":"",
					"categoria_anuncios_4":"",
					"categoria_anuncios_5":"",
					"mostrar_texto":"",
					"texto_promocion":"",
					"duracion_video_anuncio":"",
					"promocion_activa":"",
                    "descrip":["","català","english"]  
		},
	},



	"counters":{
		"fields":{
					"title":"",
					"clinica":"",
					"preview":"",
					"reproduccions":"",
					"reproduccions_tv":""  

		},
	},






           "categories_rel":{
		"fields":{
			"categories":""
		}
	},
	"TEMPLATE":{
		"fields":{},
		"collections":[],
	}
}
module.exports = collectionMeta;


// WEBPACK FOOTER //
// ./src/config/firestoreschema.js